import { components } from "react-select";
import {
  GET_INCIDENTS,
  GET_INCIDENTS_SUCCESS,
  GET_INCIDENTS_FAIL,
  CREATE_INCIDENT,
  CREATE_INCIDENT_SUCCESS,
  CREATE_INCIDENT_FAIL,
  GET_INCIDENT_BY_ID_SUCCESS,
  GET_INCIDENT_BY_ID_FAIL,
  UPDATE_INCIDENT_SUCCESS,
  UPDATE_INCIDENT_FAIL,
  CREATE_COMPONENT_SERVICE_SUCCESS,
  CREATE_COMPONENT_SERVICE_FAIL,
  GET_COMPONENT_SERVICES_SUCCESS,
  GET_COMPONENT_SERVICES_FAIL,
  GET_STATUS_PAGE_PUBLIC,
  GET_STATUS_PAGE_PUBLIC_SUCCESS,
  GET_STATUS_PAGE_PUBLIC_FAIL,
  GET_TIMESTAMP_DATA_SUCCESS,
  GET_TIMESTAMP_DATA_FAIL,
  GET_UPTIME_DETAILS_SUCCESS,
  GET_UPTIME_DETAILS_FAIL,
  DELETE_COMPONENT_SERVICE_SUCCESS,
  GET_TIMESTAMP_DATA_FOR_ONE_DAY_SUCCESS,
  GET_TIMESTAMP_DATA_FOR_ONE_DAY_FAIL,
  GET_COMPONENT_SERVICES_PUBLIC_PAGE_SUCCESS,
  GET_COMPONENT_SERVICES_PUBLIC_PAGE_FAIL,
  GET_INCIDENTS_PUBLIC_PAGE_SUCCESS,
  GET_INCIDENTS_PUBLIC_PAGE_FAIL,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FAIL,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_SUCCESS,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_SUCCESS,
  GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_FAIL,
  VERIFY_RECAPTCHA_SUCCESS,
  VERIFY_RECAPTCHA_FAIL,
  VERIFY_RECAPTCHA,
  STATUS_PAGE_EMAIL_CONFIRMATION,
  STATUS_PAGE_EMAIL_CONFIRMATION_SUCCESS,
  STATUS_PAGE_EMAIL_CONFIRMATION_FAIL,
  GET_EXTERNAL_COMPONENT_SERVICES_SUCCESS,
  GET_EXTERNAL_COMPONENT_SERVICES_FAIL,
  GET_AWS_HEALTH_EVENT_SUCCESS,
  GET_AWS_HEALTH_EVENT_FAIL,
  GET_MAPPED_ALERTS_SUCCESS,
  GET_MAPPED_ALERTS_FAIL,
  GET_ALL_RESOURCES,
  GET_ALL_RESOURCES_SUCCESS,
  GET_ALL_RESOURCES_FAIL,
  GET_RESOURCES_COUNT,
  GET_RESOURCES_COUNT_SUCCESS,
  GET_RESOURCES_COUNT_FAIL
} from "./actionTypes";

const INIT_STATE = {
    incidents: [],
    components: [],
    error: null,
  is_status_page_public_details: {
      'statuspage_enabled': false,
      "org_name":''
  },
  page_loading: true,
  time_stamp_data: [],
  time_stamp_data_for_one_day: [],
  uptime_details: [],
  recaptchaVerified: false,
  recaptchaError: null,
  status_page_confirmation_status: '',
  external_components: [],
  aws_health_events: [],
  all_alerts:[],
  all_resources: [],
  resources_count: 0,
  mapped_alerts:[],

};

const Incidents = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_INCIDENTS_SUCCESS:
            return {
                ...state,
                incidents: action.payload,
            };
        case GET_INCIDENTS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case CREATE_INCIDENT:
            return {
                ...state,
            };

        case CREATE_INCIDENT_SUCCESS:
        return {
            ...state,
            incidents: [...state.incidents, action.payload]
        };

        case CREATE_INCIDENT_FAIL:
        return {
            ...state,
            error: action.payload
        };

        case CREATE_COMPONENT_SERVICE_SUCCESS:
        return {
          ...state,
          incidents: action.payload
        };
        case CREATE_COMPONENT_SERVICE_FAIL:
        return {
          ...state,
          error: action.payload
        };
        case GET_INCIDENT_BY_ID_SUCCESS:
        return {
          ...state,
          incident: action.payload,
        }
        case GET_COMPONENT_SERVICES_SUCCESS:
          return {
            ...state,
            components: action.payload,
          }

          case GET_COMPONENT_SERVICES_FAIL:
          return {
            ...state,
            error: action.payload,
          }


        case GET_INCIDENT_BY_ID_FAIL:
          return {
            ...state,
            error: action.payload,
          }

          case UPDATE_INCIDENT_SUCCESS:
            return {
              ...state,
              incidents: state.incidents.map(incident =>
                incident.id === action.payload.id
                  ? { ...incident, ...action.payload }
                  : incident
              ),
              incident: action.payload
            }

        case UPDATE_INCIDENT_FAIL:
          return {
            ...state,
            error: action.payload,
          }
      case GET_STATUS_PAGE_PUBLIC_SUCCESS:
        return {
          ...state,
          is_status_page_public_details:action.payload,
          page_loading: false
        }
      case GET_STATUS_PAGE_PUBLIC_FAIL:
        return {
          ...state,
          error: action.payload,
          page_loading: false
        }
        case GET_STATUS_PAGE_PUBLIC:
          return {
            ...state,
            page_loading: true
          }
        case GET_TIMESTAMP_DATA_SUCCESS:
          return {
            ...state,
            time_stamp_data: action.payload
          }
      case GET_TIMESTAMP_DATA_FAIL:
        return {
          ...state,
          error: action.payload
        }
      case GET_TIMESTAMP_DATA_FOR_ONE_DAY_SUCCESS:
        return {
          ...state,
          time_stamp_data_for_one_day: action.payload
        }
      case GET_TIMESTAMP_DATA_FOR_ONE_DAY_FAIL:
        return {
          ...state,
          error: action.payload
        }
      case GET_UPTIME_DETAILS_SUCCESS:
        return {
          ...state,
          uptime_details: action.payload
        }
      case GET_UPTIME_DETAILS_FAIL:
        return {
          ...state,
          error: action.payload
        }
      case DELETE_COMPONENT_SERVICE_SUCCESS:
        return {
          ...state,
          components: action.payload
        }

      case GET_COMPONENT_SERVICES_PUBLIC_PAGE_SUCCESS:
        return {
          ...state,
          components: action.payload,
        }

      case GET_COMPONENT_SERVICES_PUBLIC_PAGE_FAIL:
        return {
          ...state,
          error: action.payload,
        }

      case GET_INCIDENTS_PUBLIC_PAGE_SUCCESS:
        return {
          ...state,
          incidents: action.payload,
        };
      case GET_INCIDENTS_PUBLIC_PAGE_FAIL:
        return {
          ...state,
          error: action.payload,
        };

      case GET_TIMESTAMP_DATA_PUBLIC_PAGE_SUCCESS:
        return {
          ...state,
          time_stamp_data: action.payload
        }
      case GET_TIMESTAMP_DATA_PUBLIC_PAGE_FAIL:
        return {
          ...state,
          error: action.payload
        }
      case GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_SUCCESS:
        return {
          ...state,
          time_stamp_data_for_one_day: action.payload
        }
      case GET_TIMESTAMP_DATA_PUBLIC_PAGE_FOR_ONE_DAY_FAIL:
        return {
          ...state,
          error: action.payload
        }

      case VERIFY_RECAPTCHA:
        return {
          ...state,
          recaptchaVerified: false,
          recaptchaError: null
        };

      case VERIFY_RECAPTCHA_SUCCESS:
        return {
          ...state,
          recaptchaVerified: true,
          recaptchaError: null
        };

      case VERIFY_RECAPTCHA_FAIL:
        return {
          ...state,
          recaptchaVerified: false,
          recaptchaError: action.payload
        };

      case STATUS_PAGE_EMAIL_CONFIRMATION:
        return {
          ...state,
          status_page_confirmation_status: ''
        };

      case STATUS_PAGE_EMAIL_CONFIRMATION_SUCCESS:
        return {
          ...state,
          status_page_confirmation_status: action.payload
        };

      case STATUS_PAGE_EMAIL_CONFIRMATION_FAIL:
        return {
          ...state,
          status_page_confirmation_status: action.payload
        };
      case GET_EXTERNAL_COMPONENT_SERVICES_SUCCESS:
        return {
          ...state,
          external_components: action.payload,
        }

      case GET_EXTERNAL_COMPONENT_SERVICES_FAIL:
        return {
          ...state,
          error: action.payload,
        }

      case GET_AWS_HEALTH_EVENT_SUCCESS:
        return {
          ...state,
          aws_health_events: action.payload
        }

      case GET_AWS_HEALTH_EVENT_FAIL:
        return {
          ...state,
          error: action.payload,
        }
      case GET_MAPPED_ALERTS_SUCCESS:
        return {
          ...state,
          mapped_alerts: action.payload
        }
      case GET_MAPPED_ALERTS_FAIL:
        return {
          ...state,
          error: action.payload,
        }
      case GET_ALL_RESOURCES:
        return {
          ...state,
          loading: true
        }
      case GET_ALL_RESOURCES_SUCCESS:
        return {
          ...state,
          all_resources: action.payload,
          loading: false
        }
      case GET_ALL_RESOURCES_FAIL:
        return {
          ...state,
          error: action.payload,
          loading: false
        }
      case GET_RESOURCES_COUNT:
        return {
          ...state,
          loading: true
        }
      case GET_RESOURCES_COUNT_SUCCESS:
        return {
          ...state,
          resources_count: action.payload.resources_count || 0,
          loading: false
        }
      case GET_RESOURCES_COUNT_FAIL:
        return {
          ...state,
          error: action.payload,
          loading: false
        }

      default:
          return state;
    }
};

export default Incidents;